import { h, Component } from 'preact';
import s from 'components/bolt/upWorld/easterEgg.sss';
import { joinClasses } from 'utils/utils';
import { easterEggAssets } from '../../../helpers/upWorldData';
import Store from 'store/store';

export default class EasterEgg extends Component {
	constructor(props) {
		super(props);
		this.props = props;
		this.playVideo = this.playVideo.bind(this);
		this.onPlay = this.onPlay.bind(this);
		this.onPause = this.onPause.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.progressTracker = this.progressTracker.bind(this);

		this.$video0;
		this.$video1;
		this.$video2;
	}

	componentDidMount() {
		Store.on('CLOSE_UPWORLD_EASTER_EGG', (e) => this.handleClose(e));
	}

	componentWillUnmount() {
		cancelAnimationFrame(this.timer);
	}

	playVideo(vidNum) {
		if (!this.videoIsPlaying) {
			this['$video' + vidNum].currentTime = 0;
			this['$video' + vidNum].play();
		}
	}

	onPlay() {
		this.videoIsPlaying = true;
		Store.emit('PAUSE_MUSIC');
		this.progressTracking = {};
		this.progressTracker();
	}

	onPause() {
		this.videoIsPlaying = false;
		Store.emit('RESUME_MUSIC');
		cancelAnimationFrame(this.timer);
	}

	handleClose(e) {
		e.stopPropagation();
		const { easterEggNum, isOpen, onClose } = this.props;
		if (isOpen) {
			if (this.videoIsPlaying) {
				this['$video' + easterEggNum].pause();
				this.videoIsPlaying = false;
				Store.emit('RESUME_MUSIC');
			}
			onClose();
			cancelAnimationFrame(this.timer);
		}
	}

	progressTracker() {
		const { easterEggNum } = this.props;
		if (!this['$video' + easterEggNum] || !this.videoIsPlaying ) {
			return;
		}
		const progress = this['$video' + easterEggNum].currentTime / this['$video' + easterEggNum].duration;
		let step = [0, 25, 50, 75, 95].find(step => progress > (step / 100) && !this.progressTracking[step]);

		if (step || step === 0) {
			this.progressTracking[step] = true;

			Store.emit('CUSTOM_EVENT', {
				category: 'up-world',
				action: 'easter-egg-video-playback',
				label: `${step} percentage completion`
			});
		}

		this.timer = requestAnimationFrame(this.progressTracker);
	}

	render() {
		//convert close button from png to webp
		const { imageRoot, videoRoot, isOpen, easterEggNum, copy } = this.props;
		//const url = easterEggAssets[easterEggNum].url;

		if (this['$video' + easterEggNum]) {
			if (isOpen) {
				this.playVideo(easterEggNum);
			}
		}
		return (
			<div class={joinClasses(s.container, isOpen && s.open)}>
				<div class={joinClasses(s.panel, isOpen && s.open)}>
					<div class={s.assetContainer}>
						<h1 class={s.title}>{copy.$upWorld.easterEggHeading}</h1>
						<button class={s.closeBtn} onClick={(e) => this.handleClose(e)}>
							<img class={s.closeBtnImg} src={`${imageRoot}/closebtn.webp`} />
							<img class={s.hoverCloseBtnImg} src={`${imageRoot}/hjmp3s.webp`} />
						</button>
						{easterEggAssets.map((asset, i) => (
							<video ref={video => this['$video' + i] = video} class={joinClasses(s.asset, easterEggNum == i && s.show)} muted={false} playsinline controls onPause ={this.onPause} onPlay={this.onPlay} onEnded={(e) => this.handleClose(e)} poster={`${imageRoot}/up/${asset.url}.webp`}>
								<source src={`${videoRoot}/up/${asset.url}.mp4`} type={'video/mp4'} />
								<source src={`${videoRoot}/up/${asset.url}.webm`} type={'video/webm'} />
							</video>
						))}
					</div>
				</div>
			</div>
		);
	}
}